export default "__VITE_ASSET__B55O7H3t__"